import { gsap, ScrollTrigger } from '../global/gsap';
import initLazyVideo from '../utilities/lazy-video';

const initStoryFilter = (filterEl, cardsWrapEl) => {
    const filterButtons = filterEl.querySelectorAll('.js-filter-button');
    const filterReset = document.querySelector('.js-filter-reset');


    function fetchResults(url) {
        // Add working class
        document.body.classList.add('working');

        // Get current content to animate out
        const currentContent = cardsWrapEl.querySelector('.js-cards');

        let loadedCards;

        // Fetch html from rendered pag
        fetch(url).then((response) => response.text()).then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Get content element
            const content = doc.querySelector('.js-cards');

            if (content) {
                // Get new content and hide
                loadedCards = content.querySelectorAll('.js-card');

                if (loadedCards && loadedCards.length > 0) {
                    gsap.set(loadedCards, {
                        opacity: 0
                    });
                }

                gsap.to(currentContent, {
                    opacity: 0,
                    duration: 0.25,
                    overwrite: true,
                    onComplete: () => {
                        // Clear card wrap element
                        cardsWrapEl.innerHTML = '';

                        // Add new content to wrap element
                        cardsWrapEl.insertBefore(content, null);

                        // Fade in new content
                        if (loadedCards && loadedCards.length > 0) {
                            ScrollTrigger.batch(loadedCards, {
                                invalidateOnRefresh: true,
                                start: 'top 95%',
                                onEnter: (batch) => gsap.to(
                                    batch, {
                                    duration: 0.7,
                                    opacity: 1,
                                    stagger: 0.05,
                                    ease: 'power2'
                                }
                                )
                            });
                        }

                        // Initiate any new lazy load videos
                        const lazyVideoEls = cardsWrapEl.querySelectorAll('video.js-lazy');

                        if (lazyVideoEls && lazyVideoEls.length > 0) {
                            initLazyVideo(lazyVideoEls);
                        }

                        // Force ST refresh
                        window.dispatchEvent(new Event('resize'));
                        ScrollTrigger.refresh();

                        document.body.classList.remove('working');
                    }
                });
            } else {
                document.body.classList.remove('working');
                return;
            }
        }).catch((err) => {
            // There was an error
            console.warn('Something went wrong.', err);
        });
    }

    function updateFilters(filter) {
        // Get current URL params
        let resultsUrl = new URL(window.location.href);
        const resultsUrlParams = resultsUrl.searchParams;
        const filterCat = filter.dataset.category;

        filterButtons.forEach(button => {
            button.classList.remove('is-active');
        })

        filterReset.classList.remove('is-active');

        // If triggered by form input
        if (filter) {
            if(resultsUrlParams.has('category', filterCat)) {
                resultsUrl.searchParams.delete('category');
                filter.classList.remove('is-active');
                filterReset.classList.add('is-active');
            } else {
                resultsUrl.searchParams.set('category', filterCat);
                filter.classList.add('is-active');
                filterReset.classList.remove('is-active');
            }
        // Otherwise, trigged by reset button
        } else {
            resultsUrl = `${document.body.dataset.site}/${document.body.dataset.page}/`;

            filterButtons.forEach((button) => {
                button.classList.remove('is-active');
            });

            resetButton.classList.add('is-active')
        }

        window.history.pushState({}, '', resultsUrl);
        fetchResults(resultsUrl);
    }


    filterButtons.forEach(button => {
        button.addEventListener('click', () => {
            updateFilters(button);
        })
    });

    // Filter reset actions
    if (filterReset) {
        filterReset.addEventListener('click', () => {
            updateFilters(filterReset);
        });
    }

    // Pop state logic
    window.addEventListener('popstate', (event) => {
        const popUrl = event.target.location.href;
        const popUrlFormatted = new URL(popUrl);
        const popParams = popUrlFormatted.searchParams;

        filterButtons.forEach((button) => {
            button.classList.remove('is-active');
        });

        // Update filter inputs based on params
        if (popParams && popParams.size > 0) {
            popParams.forEach((value) => {
                const filters = value.split(',');

                filters.forEach((filter) => {
                    if (filter) {
                        const activeInputs = [...filterButtons].filter((element) => element.id === filter);

                        activeInputs.forEach((input) => {
                            input.checked = true;
                            input.classList.add('active');
                        });
                    }
                });
            });
        }

        fetchResults(popUrl);
    });
};

export default initStoryFilter;
